import React, { useState } from "react";
import {
  FaAndroid,
  FaDesktop,
  FaGlobe,
  FaMobileAlt,
  FaShoppingCart,
  FaUserTie,
} from "react-icons/fa";
import { HiBadgeCheck } from "react-icons/hi";
import badge_view from "../../../assets/Docs/badge_view.png";
import badge_add from "../../../assets/Docs/Add_badge.png";
import All_badge_view from "../../../assets/Docs/view_all_badge.png";
import { TagComponent } from "../Tabs";

const Badges = () => {

  const [activeTab1, setActiveTab1] = useState("web");
  const [activeTab2, setActiveTab2] = useState("web");

  const tabs = [
    { id: "web", label: "Web App", icon: <FaDesktop /> },
    {
      id: "mobile",
      label: "Mobile App",
      icon: <FaMobileAlt />,
      disabled: true,
    },
  ];
  const renderTabs = (activeState, setActiveState) => (
    <div className="flex flex-col sm:flex-row gap-2 border-b border-[#b9ece6] sm:gap-4 mb-6">
      {tabs.map((tab) => (
        <button
          key={tab.id}
          onClick={() => !tab.disabled && setActiveState(tab.id)}
          className={`flex items-center justify-center sm:justify-start gap-2 px-4 py-2 rounded-t-md transition-all text-sm w-full sm:w-auto ${activeState === tab.id
            ? "bg-[#1a9588] text-white shadow-md"
            : "bg-[#dbf4f1] text-gray-700 hover:bg-[#b9ece6]"
            } ${tab.disabled ? "opacity-50 cursor-not-allowed" : ""}`}
          disabled={tab.disabled}
        >
          {tab.icon}
          {tab.label}
        </button>
      ))}
    </div>
  );

  return (
    <div className="bg-white shadow-lg rounded-xl p-6 sm:p-8  mx-auto border border-gray-200" id="top">

      <div className="flex items-center mb-6 border-b pb-4 border-gray-200">
        <HiBadgeCheck className="text-4xl text-theme-logo-color mr-3" />
        <h1 className="text-2xl sm:text-3xl font-bold text-theme-logo-color">Badges </h1>
      </div>

      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-8 gap-4">
        <div className="flex flex-wrap gap-3">
          <TagComponent icon={<FaUserTie />} label="Seller" color="green" />
          <TagComponent icon={<FaShoppingCart />} label="Buyer" color="pink" />
        </div>
        <div className="flex flex-wrap gap-3">
          <TagComponent icon={<FaGlobe />} label="Web" color="green" />
          <TagComponent icon={<FaAndroid />} label="Android" color="green" />
        </div>
      </div>


      <p className="text-start mb-6 text-gray-600 text-gray-300">
        Easily create nice looking badges to label & highlight your products.
      </p>

      
      {/* <div className="text-start">
                <h3 className="text-2xl text-gray-500 mb-2">Adding / Updating Products</h3>
                <p className="text-gray-600 mb-6">
                    Go to the 'Products' section & click on 'Add New'. Fill in the fields and click 'Save'. The new product is saved to the database.
                </p>
            </div> */}
      {renderTabs(activeTab1, setActiveTab1)}
      <div className="rounded-lg p-2 sm:p-4 flex justify-start">
        <img
          src={badge_view}
          alt={`${activeTab1} view`}
          className="rounded-lg border max-w-full h-auto max-h-[80vh] object-contain"
        />
      </div>
      <div>
        <div className="text-start">
          <h3 className="text-2xl text-gray-500 mb-2">Add / Update Badge</h3>
          <p className="text-gray-600 mb-6">
            Badges can be managed in the 'Settings' section. To create a new
            badge, click 'Add New' and specify the badge label, background
            color, and text color.
          </p>
        </div>
        {renderTabs(activeTab2, setActiveTab2)}
        <div className="rounded-lg p-2 sm:p-4 flex justify-start">
          <img
            src={badge_add}
            alt={`${activeTab2} view`}
            className="rounded-lg border max-w-full h-auto max-h-[80vh] object-contain"
          />
        </div>
      </div>

      <div className="bg-red-100 text-red-800 p-4 rounded-lg border border-red-300 text-start">
        Badge once defined cannot be deleted.
      </div>

      <div className="my-5">
        {renderTabs(activeTab2, setActiveTab2)}
        <div className="rounded-lg p-2 sm:p-4 flex justify-start">
          <img
            src={All_badge_view}
            alt={`${activeTab2} view`}
            className="rounded-lg border max-w-full h-auto max-h-[80vh] object-contain"
          />
        </div>

        <div className="bg-yellow-100 text-yellow-800 p-4 rounded-lg border border-yellow-300 text-start">
          Use the toggle to show or hide a badge on all products. The changes
          will apply only after you publish your product data.
        </div>
      </div>
    </div>
  );
};

export default Badges;
